<div class="header-bar">
  <h1>Terms & Conditions</h1>
</div>
<div class="">
  <div class="" style="position: relative">
    <div class="content-container">
      <div *ngIf="warnings && warnings.length > 0" class="ui-grid-row">
        <ul style="list-style: none">
          <li *ngFor="let warning of warnings">
            <i class="fa fa-exclamation-triangle" aria-hidden="true" style="margin-right: 10px"></i>
            <span>{{ warning }}</span>
          </li>
        </ul>
      </div>
      <div class="ui-grid-row">
        <div class="ui-g-12">
          <p-table
            [value]="page.items"
            [rows]="10"
            [paginator]="true"
            [pageLinks]="3"
            [responsive]="true"
            [rowsPerPageOptions]="[5, 10, 20]"
            selectionMode="single"
            [(selection)]="selectedTerms"
            sortField="createdOn"
            [sortOrder]="-1"
            [lazy]="true"
            [totalRecords]="page.total"
            (onLazyLoad)="onGridLazyLoad($event)"
            [hidden]="!isLoaded"
          >
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="version">Version</th>
                <th pSortableColumn="createdOn">Created On</th>
                <th pSortableColumn="updatedOn">Updated On</th>
                <th pSortableColumn="updatedOn">Type</th>
                <th pSortableColumn="organisationTypeId">Organisation Type</th>
                <th pSortableColumn="audienceTypeId">Specific Audience</th>

                <th pSortableColumn="documentUrl">Is Actual</th>
                <th>PDF</th>
                <th>Html Url</th>
                <th>Required Date</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr [pSelectableRow]="item" (dblclick)="showEditDialog(item)">
                <td>
                  <div [class.cell-bold]="item.isActual">
                    {{ item.version }}
                  </div>
                </td>
                <td>{{ item.createdOn | date : 'dd/MM/y' }}</td>
                <td>{{ item.updatedOn | date : 'dd/MM/y' }}</td>
                <td>{{ item.type == 0 ? 'Agreement' : 'Terms of Use' }}</td>
                <td>{{ item.organisationTypeId == 2 ? 'Customer' : 'Supplier' }}</td>
                <td>{{ getAudienceTypeLabel(item.audienceTypeId) }}</td>
                <td>{{ item.isActual ? 'Yes' : 'No' }}</td>
                <td>
                  <a
                    *ngIf="item.documentUrl"
                    href="#"
                    (click)="downloadPdf(item.documentUrl); $event.preventDefault()"
                    >Download</a
                  >
                </td>
                <td>
                  <div style="word-wrap: break-word">{{ item.htmlUrl }}</div>
                </td>
                <td>{{ item.requiredByDate | date : 'dd/MM/y' }}</td>
              </tr>
            </ng-template>
          </p-table>
          <!--- DATATABLE DEPRECATED ----
                    <p-dataTabl [value]="page.items" [rows]="10" [paginator]="true" [pageLinks]="3" [responsive] = "true"
                                 [rowsPerPageOptions]="[5,10,20]" selectionMode="single" [(selection)]="selectedTerms"
                                 (onRowDblclick)="showEditDialog(selectedTerms)" sortField="createdOn" [sortOrder]="-1" [lazy]="true"
                                 [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" [hidden]="!isLoaded">
                        <p-column field="version" header="Version" [sortable]="tru">
                            <ng-template pTemplate="body" let-item="rowData">
                                <div [class.cell-bold]="item.isActual">
                                    {{item.version}}
                                </div>
                            </ng-template>
                        </p-column>
                        <p-column field="createdOn" header="Created On" [sortable]="tru" [editable]="false">
                            <ng-template pTemplate="body" let-item="rowData">
                                {{item.createdOn | date:'dd/MM/y'}}
                            </ng-template>
                        </p-column>
                        <p-column field="updatedOn" header="Updated On" [sortable]="tru" [editable]="false">
                            <ng-template pTemplate="body" let-item="rowData">
                                {{item.updatedOn | date:'dd/MM/y'}}
                            </ng-template>
                        </p-column>
                        <p-column field="organisationType" header="Organisation Type" [sortable]="tru">
                            <ng-template pTemplate="body" let-item="rowData">
                                {{item.organisationTypeId == 2 ? 'Customer' : 'Supplier'}}
                            </ng-template>
                        </p-column>
                        <p-column field="isActual" header="Is Actual" [sortable]="tru" [editable]="false" styleClass="align-center">
                            <ng-template pTemplate="body" let-item="rowData">
                                {{item.isActual ? 'Yes' : 'No'}}
                            </ng-template>
                        </p-column>
                        <p-column field="" header="PDF" [sortable]="false" [editable]="false" styleClass="align-center" >
                            <ng-template pTemplate="body" let-item="rowData">
                                <a *ngIf="item.documentUrl" href="#" (click)="downloadPdf(item.documentUrl); $event.preventDefault(); ">Download</a>
                            </ng-template>
                        </p-column>
                    </p-dataTable>
                    --->
        </div>
      </div>
      <div class="ui-grid-row">
        <div class="ui-g-12">
          <p-fileUpload
            [disabled]="!selectedTerms"
            name="file"
            url="/api/termsconditions/uploadpdf"
            accept=".pdf"
            mode="basic"
            auto="true"
            chooseLabel="Upload PDF"
            (onBeforeUpload)="onBeforeUpload(selectedTerms.id, $event)"
            (onUpload)="onUpload($event)"
            (onError)="onUploadError($event)"
            [class]="'btn-upload-to-right' + (selectedTerms ? '' : ' btn-disabled')"
          >
          </p-fileUpload>

          <button
            type="button"
            class="pull-right"
            pButton
            (click)="showEditDialog(selectedTerms)"
            label="Edit"
            icon="fa ui-icon-mode-edit"
            [disabled]="!selectedTerms"
          ></button>
          <button
            type="button"
            class="pull-right"
            pButton
            icon="fa ui-icon-add"
            (click)="showEditDialog(null)"
            label="Add"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="Terms & Conditions Details"
  [(visible)]="editDialogVisible"
  [modal]="true"
  [responsive]="true"
>
  <form [formGroup]="editTermsForm" (ngSubmit)="saveTerms(editTermsForm.value)" autocomplete="off">
    <div>
      <div class="ui-grid-row">
        <div class="ui-g-12">
          <div class="ui-g-3"><label for="dateToApplyRate">Text</label></div>
          <div class="ui-g-9">
            <textarea
              class="ui-inputtextarea"
              pInputTextarea
              formControlName="text"
              name="text"
              style="width: 100%; height: 300px"
              required
            ></textarea>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-3"><label for="version">Version</label></div>
          <div class="ui-g-3 ui-sm-9">
            <input
              pInputText
              name="version"
              maxlength="20"
              style="width: 100%"
              formControlName="version"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-3">
            <label>Html URL (A Url that link to the terms conditions)</label>
          </div>
          <div class="ui-g-3 ui-sm-9">
            <input
              pInputText
              name="htmlUrl"
              maxlength="400"
              style="width: 100%"
              formControlName="htmlUrl"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-3 ui-sm-12"><label>Type</label></div>
          <div class="ui-g-3 ui-sm-12">
            <p-dropdown
              [options]="termsAndConditionsTypeOptions"
              [style]="{ width: '100%' }"
              formControlName="type"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-3 ui-sm-12"><label>Organisation Type</label></div>
          <div class="ui-g-3 ui-sm-12">
            <p-dropdown
              [options]="orgTypeOptions"
              [style]="{ width: '100%' }"
              formControlName="organisationTypeId"
            >
            </p-dropdown>
          </div>
        </div>
        <div *ngIf="audienceTypes.length > 1" class="ui-g-12">
          <div class="ui-g-3 ui-sm-12"><label>Specific Audience</label></div>
          <div class="ui-g-3 ui-sm-12">
            <p-dropdown
              [options]="audienceTypes"
              [style]="{ width: '100%' }"
              formControlName="audienceTypeId"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-3 ui-sm-12"><label>Required By Date</label></div>
          <div class="ui-g-3 ui-sm-12">
            <p-calendar
              formControlName="requiredByDate"
              dateFormat="D d MM"
              name="requiredByDate"
              [showIcon]="true"
            ></p-calendar>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-3"><label for="isActual">Is Actual</label></div>
          <div class="ui-g-3 ui-sm-9">
            <p-checkbox name="isActual" binary="true" formControlName="isActual"></p-checkbox>
          </div>
        </div>
      </div>
      <div class="ui-grid-row">
        <div class="ui-g-4"></div>
      </div>
    </div>
    <div style="float: right">
      <button
        type="submit"
        class="green-btn"
        pButton
        icon="fa ui-icon-check"
        label="Save"
        [disabled]="editTermsForm.invalid"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        (click)="editDialogVisible = false"
      ></button>
    </div>
  </form>
</p-dialog>
